var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidenav-menu"},[_c('div',{staticClass:"nav accordion",attrs:{"id":"accordionSidenav"}},[(_vm.appTypes.length)?[_c('MenuItemRecursive',{attrs:{"options":_vm.options,"parentId":"accordionSidenav","appTypes":_vm.appTypes,"currentAppName":_vm.app.name}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }